import React, { Component, lazy, Suspense } from 'react'
import { connect } from "react-redux";
import { Container } from 'react-bootstrap';
import { getModeration, updateCheckAll, selectPostUpdate, activeTabActionFilter, dateRangeFilter, clickToPostStatusALL, clickToPostDeleteALL, searchTagsFilter, limitUpdate, onNextNavigateClick, onPrevNavigateClick, onUpdatePage, clickToRefresh, removeAllFilterBody, searchPostFilter, removeCheckAll, updateCheckStatusAll, CLEAR_UGC_REQUEST, CLEAR_UGC_DATA, ugcModal, postCarosal, onUpdateTags, filterDataAnalytics, updateRuleFilter } from '../../../../actions/moderationActions'
import { POPUP_IMAGE_RENEW_REQUEST, fadeOutEffect } from '../../../../utils'
import './moderation.scss';
import './ContentModal/modal.scss';
import { getUserTags } from '../../../../actions/loginActions';
import { toggleAutoPilot_D, togglePlanSection_D } from '../../../../actions/showDisplayModalAction';
import withRouter from '../../../CommonComponents/WithRouter';
import ErrorFound from '../../../CommonComponents/ErrorFound';
import MasonryView from './MasonryView';
import { API_URL, LIVE_API } from '../../../../actions/api';
import HttpClient from '../../../../actions/http-client';

const Header = lazy(() => import('./Header'));
const FilterBody = lazy(() => import('./Filters'));
const FilterTab = lazy(() => import('./Filters/filterTab'));
const AddUgcRights = lazy(() => import('./UgcRights'));
const UgcStatus = lazy(() => import('./UgcRights/Status'));
const Skeleton = lazy(() => import('./Elements/Skeleton'));
const EmptyWithIcon = lazy(() => import('../../../CommonComponents/Empty/EmptyWithIcon'));
const AiAutoModeration = lazy(() => import('../AiAutoModeration'));
const UpgradeAutoPilot = lazy(() => import('./Elements/UpgradeAutoPilot'));

class Moderation extends Component {
  allImageQueue = [];
  ref = React.createRef(null);
  state = { total: 0, isCheckAll: false, isCheckedPostCount: 0, perPageCount: 10, activePage: 1, filters: [], allFirstImage: false, statusPopup: 0, showFilterTab: false, aiUpgrade: null, filterTab: 0 }
  unRecommendedList = [];
  RecomendedList = []

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.moderation.changeModeration_wall !== this.props.moderation.changeModeration_wall && this.props.moderation.changeModeration_wall) this.setState({ activeTab: this.props.moderation?.filter?.status }, this.clickToUncheckAll)
  }

  componentWillMount() {
    const { params, userDetails, getTags } = this.props;
    const currentUrl = window.location.href;
    const newUrl = currentUrl.replace(params?.id, localStorage.getItem('wallId'));
    window.history.pushState(null, '', newUrl);
    window.feedId = params.feedId;
    if (!userDetails?.userTags) {
      getTags(localStorage.getItem('ownerId'));
    }
    this.callbackFilter();
  }

  componentDidMount() {
    document.cookie = "callBackUrl=React";
    localStorage.removeItem('createFeedObj')
    this.props.getModeration();
  }

  componentWillUnmount() {
    this.allImageQueue = [];
    this.props.removeAllFilterBody(true)
  }

  callbackFilter = () => {
    this.props.removeAllFilterBody(true)
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    let data = ""
    const urlParams = ['language', 'network', 'media', 'tags', 'sentiments', 'recommendation'];
    const getFilter = urlParams.find(item => url.href.includes(item))
    data = [{ 'filter': getFilter, 'data': params.get(getFilter) }]
    data && this.props.filterDataAnalytics(data)

    if (window.location.pathname?.includes('notificationId')) {
      setTimeout(() => {
        const ruleName = localStorage.getItem('rule-notification');
        if (ruleName) {
          localStorage.removeItem('rule-notification');
          this.props.updateRuleFilter(ruleName);
        }
      }, 2000)
      setTimeout(() => this.props.getModeration(), 1000)
    }
  }

  clickToCheckAll = event => {
    const { isCheckAll } = this.state;
    this.setState({ isCheckAll: !isCheckAll }, () => {
      this.onActionUpdateOpcity()
      this.props.updateCheckAll(this.state.isCheckAll)
    })
  }

  clickToCheckStatusAll = (status) => event => {
    this.onActionUpdateOpcity()
    this.props.updateCheckStatusAll(status)
  }

  clickToUncheckAll = event => {
    this.setState({ isCheckAll: false }, () => {
      this.onActionUpdateOpcity()
      this.props.removeCheckAll(false)
    })
  }

  clickPostChecked = (index) => event => this.props.selectPostUpdate(index, this.onActionUpdateOpcity())

  onActionUpdateOpcity = () => {
    const { isCheckAll, isCheckedPostCount } = this.state;
    if (isCheckAll || (isCheckedPostCount > 0)) {
      if (document.getElementsByClassName("modSelectNo") && document.getElementsByClassName("modSelectNo")[0])
        fadeOutEffect(document.getElementsByClassName("modSelectNo")[0])
      if (document.getElementsByClassName("filter-bar") && document.getElementsByClassName("filter-bar")[0]) fadeOutEffect(document.getElementsByClassName("filter-bar")[0])
    }
  }

  clickToTab = (activeTab) => event => this.props.activeTabActionFilter(activeTab)

  onDateRangeFilter = (startDate, endDate) => this.props.dateRangeFilter(startDate, endDate)

  onClickToFilterUpdateStatus = (status) => event => this.props.clickToPostStatusALL(status)
  onClickToFilterDeleteAll = event => this.props.clickToPostDeleteALL(this.props.navigate)
  onClickNextPage = event => this.props.onNextNavigateClick()
  onClickPrevPage = event => this.props.onPrevNavigateClick()
  onChangePage = (page) => event => { this.props.onUpdatePage(page) }


  onClickReset = (item) => {
    let tempFilter = this.state.filters.filter(i => i.key === item.key)
    tempFilter = tempFilter.filter((it) => {
      if (["postType", "socialFeed", "other"].includes(it.key))
        return it.value.filter((j) => !item.value.includes(j));
    });
    this.setState({ filters: tempFilter }, () => this.props.clickToRefresh())
  }

  onClickAllReset = event => this.setState({ filters: [] }, () => this.props.getModeration())
  upgradeTrueSensePlan = () => this.setState({ aiUpgrade: null }, () => setTimeout(() => this.props.upgradePlan(), 100));
  showAiUpgradePop = (type) => this.setState({ aiUpgrade: type, autoMod: false });


  handleAllImageError = (e) => {
    try {
      const src = e.target.getAttribute("data-id");
      if (!this.allImageQueue.some(item => item.src === src)) {
        this.allImageQueue.push({ src, e });
      }
      if (!this.state.allFirstImage) {
        this.processAllImageQueue();
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  processAllImageQueue = async () => {
    const queue = this.allImageQueue;
    if (queue.length && !this.state.allFirstImage) {
      this.setState({ allFirstImage: true });
      this.processNextImage();
    }
  };

  processNextImage = () => {
    try {
      const { src, e } = this.allImageQueue[0];
      if (src) {
        POPUP_IMAGE_RENEW_REQUEST(e, this.nextProcessAllImageQueue);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  nextProcessAllImageQueue = () => {
    try {
      this.allImageQueue.shift();
      if (this.allImageQueue.length) {
        this.processNextImage();
      } else {
        this.setState({ allFirstImage: false });
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  updatepostCarosal = (status) => {
    const { allWalls, galleryUpdate, postCarosal } = this.props
    postCarosal(status)

    const getWallData = allWalls?.length && allWalls.find((e) => e.id == localStorage.getItem('wallId'))
    if (getWallData) galleryUpdate({ name: getWallData.name, status, carouselPost: status, autoUpdate: getWallData.autoUpdate || 0, deleted: 0, id: getWallData.id, action: 2 })
  }

  openugcModel = () => this.props.ugcModal(true)
  onShow = (id) => this.setState({ statusPopup: id })

  hideFilterBody = (status = 0) => {
    this.setState((prev) => ({ ...prev, showFilterTab: !status ? !this.state.showFilterTab : false }));
  }
  componentWillUnmount() {
    this.props.removeAllFilterBody()
    this.unRecommendedList = [];
  }

  isSentimentValid = (sentiment) => {
    return ((sentiment == null || sentiment == '' || sentiment == 'negative' || sentiment == 'postive' || sentiment == 'strongpos' || sentiment == 'neutral' || sentiment == 'strongneg' || sentiment == 0) && sentiment != '0.00');
  }

  getNotRecomendedList = (item) => {

    const { moderation, userDetails, loader } = this.props;
    const email = userDetails?.userData?.user?.emailId;
    const keywords = ['@taggbox', '@taggshop', '@tagembed'];

    if (LIVE_API && moderation && userDetails?.userData?.UserRule?.id != '133693' && userDetails?.userData?.user?.trueSense && (!keywords.some(keyword => email.includes(keyword)) || userDetails?.userData?.UserRule?.wasabi_upload == 1)) {

      if ([1, 2, 3, 4, 5].includes(parseInt(item.type)) && (this.isSentimentValid(item.sentiment) || !item.recommendation) && item.status != 3) {
        if (!loader.filterLoader) {

          const result = this.unRecommendedList.find((e => e.id == item.id))
          if (!result) {
            this.unRecommendedList.push({ id: item.id, wallId: localStorage.getItem('wallId') });
            if (this.unRecommendedList.length == 1) {
              this.getRecommemdation();
            }
          }
        } else this.unRecommendedList = [];
      }
    } else this.unRecommendedList = [];

  }


  getRecommemdation = () => {
    try {
      if (this.unRecommendedList.length > 0) {
        const { userData } = this.props.userDetails;
        new HttpClient().post(`${API_URL}/accounts/getsentimentAI`, {
          postId: this.unRecommendedList[0].id,
          table_name: userData.UserPlan.db_table
        }).then((response) => {
          const { responseData } = response.data;
          if (localStorage.getItem('wallId') != this.unRecommendedList[0].wallId) {
            throw new Error('error')
          }
          if (responseData && Object.keys(responseData).length > 0) {
            const posts = this.props.moderation.listData;
            const updatedList = posts.map(post => {
              if (post.id == this.unRecommendedList[0].id) {
                return { ...post, ...responseData }
              }
              return post;
            });
            if (!this.props.loader.filterLoader) {
              this.props.updateList(updatedList);
            } else {
              this.unRecommendedList = [];
            }
          }
          this.unRecommendedList.shift();
          this.getRecommemdation()
        }).catch((error) => {
          this.unRecommendedList.shift();
          this.getRecommemdation()
        })
      }
    } catch (error) {
      console.log("error---recommendation")
      this.unRecommendedList = [];
    }
  }


  render() {
    const { isCheckAll, perPageCount, activePage, filters, aiUpgrade, showFilterTab, filterTab } = this.state;
    const { moderation, searchTagsFilter, limitUpdate, loader, postCarosal, showAutoPilotD, userDetails, clickToRefresh, ugcModal, clearUgcData, removeAllFilterBody, searchPostFilter, allWalls, wallsLoader, feeds, ugcData, ugcPopup, UGC_DATA_RM, navigate, getTags, toggleAutoPilot, onUpdateTags, upgradePlan, wallData } = this.props;
    const activeTab = moderation?.filter?.status;
    return (
      <div className="d-flex flex-column flex-column-fluid full-content moderation__">
        <Suspense fallback={<></>}><Header postCarosal={this.updatepostCarosal} clickToRefresh={clickToRefresh}  {...this.props} {...this.state} clickToCheckAll={this.clickToCheckStatusAll} clickToUncheckAll={this.clickToUncheckAll} isCheckedPostCount={moderation?.isCheckedPostCount} onClickToViewFilter={this.onClickToViewFilter} total={moderation?.total} clickToTab={this.clickToTab} onDateRangeFilter={this.onDateRangeFilter} onClickToFilterUpdateStatus={this.onClickToFilterUpdateStatus} onClickToFilterDeleteAll={this.onClickToFilterDeleteAll} onNextNavigateClick={this.onClickNextPage} onPrevNavigateClick={this.onClickPrevPage} onChangePage={this.onChangePage} onAppliedFilter={this.onAppliedFilter} activeTab={activeTab} key={activeTab} changeFilterTab={(e) => this.setState({ filterTab: e })} /></Suspense>
        <Container fluid className='position-relative py-3 dual_subheader_content'>
          <Suspense fallback={<></>}><FilterBody {...this.props} filterBody={moderation.filterBody} showFilterTab={showFilterTab} filterTab={filterTab} hideFilterBody={this.hideFilterBody} showAiUpgradePop={this.showAiUpgradePop} changeFilterTab={(e) => this.setState({ filterTab: e })} /></Suspense>
          <Suspense fallback={<></>}><FilterTab  {...this.props} filterBody={moderation.filterBody} filters={moderation.filter} /></Suspense>
          <Suspense fallback={<></>}><UgcStatus {...this.props} statusPopup={this.state.statusPopup} onHide={() => { this.setState({ statusPopup: 0 }); UGC_DATA_RM() }} openugcModel={this.openugcModel} /></Suspense>

          {(moderation?.total == 0 && !moderation?.filterLoader && !(moderation?.filter?.status == 3 && moderation?.listData?.length > 0)) ?
            <div className="f-center" style={{ minHeight: 'calc(100vh - 228px)' }}>
              <Suspense fallback={<></>}><EmptyWithIcon title={feeds && feeds.length ? 'No Posts!' : 'Whoops! You have not created a feed! ⌛'} desc={''} icon={'media'} isFullScreen={false} /></Suspense>
            </div>
            :
            <div className="moderation_card tab-content" ref={this.ref}>
              {loader.filterLoader ? <Suspense fallback={<></>}><Skeleton {...this.props} /></Suspense> : <ErrorFound><Suspense fallback={<></>}><MasonryView clickPostChecked={this.clickPostChecked} getNotRecomendedList={this.getNotRecomendedList} currRef={this.ref}  {...moderation} removeAllFilterBody={removeAllFilterBody} activeTab={activeTab} searchTagsFilter={searchTagsFilter} onAppliedFilter={this.onAppliedFilter} handleAllImageError={this.handleAllImageError} filters={filters} onClickAllReset={this.onClickAllReset} onClickReset={this.onClickReset} onShow={this.onShow} navigate={navigate} upgradePlan={upgradePlan} /></Suspense></ErrorFound>}
            </div>}

          {ugcPopup ? <ErrorFound><Suspense fallback={<></>}><AddUgcRights ugcData={ugcData} hideUgc={() => { ugcModal(false); clearUgcData() }} /></Suspense></ErrorFound> : ''}
        </Container>
        {showAutoPilotD ? <Suspense fallback={<></>}><AiAutoModeration userDetails={userDetails} getTags={getTags} closeModeration={() => toggleAutoPilot(false)} showUpgradePop={this.showAiUpgradePop} moderation={moderation} /></Suspense> : null}
        {aiUpgrade ? <Suspense fallback={<></>}><UpgradeAutoPilot show={aiUpgrade} handleClose={() => this.setState({ aiUpgrade: null })} exploreSocialWall={this.upgradeTrueSensePlan} type={aiUpgrade} /></Suspense> : null}
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    moderation: state.moderation,
    loader: state.loader,
    ctaData: state.ctaData?.data,
    allFont: state.allFont,
    showAddFeed: state.modalReducer?.showAddFeed,
    showManageFeed: state.modalReducer?.showManageFeed,
    showCta: state.modalReducer?.showCta,
    wallsLoader: state.dashboardData?.wallsLoader,
    addGalleryNow: state.dashboardData?.addGalleryNow,
    ctaData: state.ctaData?.data,
    ugcData: state.moderation?.ugcData,
    ugcPopup: state.moderation?.ugcPopup,
    ugcRequestData: state.moderation?.ugcRequestData,
    feeds: state.manageFeeds?.feeds,
    allWalls: state.dashboardData?.dashboarddata?.allWalls,
    userDetails: state.authenticated,
    showAutoPilotD: state.displayModalSection?.showAutoPilotD,
    wallData: state.wallData?.wallData ?? {},
  }
}
const mapDispatchToProps = dispatch => {
  return {
    getModeration: (callback) => dispatch(getModeration(callback)),
    activeTabActionFilter: (status) => dispatch(activeTabActionFilter(status)),
    updateCheckAll: (status) => dispatch(updateCheckAll(status)),
    selectPostUpdate: (index, callBack) => dispatch(selectPostUpdate(index, callBack)),
    dateRangeFilter: (startDate, endDate) => dispatch(dateRangeFilter(startDate, endDate)),
    clickToPostStatusALL: (status) => dispatch(clickToPostStatusALL(status)),
    clickToPostDeleteALL: (navigate) => dispatch(clickToPostDeleteALL(navigate)),
    searchTagsFilter: (searchTags) => dispatch(searchTagsFilter(searchTags)),
    searchPostFilter: (searchPost) => dispatch(searchPostFilter(searchPost)),
    limitUpdate: (limit) => dispatch(limitUpdate(limit)),
    onNextNavigateClick: () => dispatch(onNextNavigateClick()),
    onPrevNavigateClick: () => dispatch(onPrevNavigateClick()),
    onUpdatePage: (page) => dispatch(onUpdatePage(page)),
    clickToRefresh: () => dispatch(clickToRefresh()),
    postCarosal: (status) => dispatch(postCarosal(status)),
    removeAllFilterBody: (status) => dispatch(removeAllFilterBody(status)),
    removeCheckAll: (data) => dispatch(removeCheckAll(data)),
    updateCheckStatusAll: (data) => dispatch(updateCheckStatusAll(data)),
    ugcModal: (state) => dispatch(ugcModal(state)),
    clearUgcData: () => dispatch(CLEAR_UGC_DATA()),
    UGC_DATA_RM: () => dispatch(CLEAR_UGC_REQUEST()),
    getTags: (ownerId) => dispatch(getUserTags(ownerId)),
    onUpdateTags: (data, isTaggModal, callback) => dispatch(onUpdateTags(data, isTaggModal, callback)),
    upgradePlan: () => dispatch(togglePlanSection_D(true)),
    toggleAutoPilot: (status) => dispatch(toggleAutoPilot_D(status)),
    filterDataAnalytics: (value) => dispatch(filterDataAnalytics(value)),
    updateRuleFilter: (value) => dispatch(updateRuleFilter(value)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(withRouter(Moderation)));
